// export default {
//   DIVISION_ADMIN: 'DIVISION_ADMIN',
//   ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN'
// }

export default {
  GLOBAL_ADMIN: 'GLOBAL_ADMIN',
  ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
  USER: 'USER'
}



// WEBPACK FOOTER //
// ./src/constants/roles.js